import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, Linkedin, ShieldCheck } from "lucide-react";
import { useSettings } from "@/lib/content";

const NAV = [
  { label: "Quem Somos", to: "/quem-somos" },
  { label: "Áreas de Atuação", to: "/areas-de-atuacao" },
  { label: "Serviços Jurídicos", to: "/servicos" },
  { label: "Para Quem Atuamos", to: "/para-quem-atuamos" },
  { label: "Palestras e Treinamentos", to: "/palestras-e-treinamentos" },
  { label: "Conteúdo Jurídico", to: "/conteudo-juridico" },
  { label: "Faça Parte", to: "/faca-parte" },
  { label: "Contato", to: "/contato" },
];

export default function Footer() {
  const { settings } = useSettings();
  const c = settings?.contact || {};
  return (
    <footer className="bg-navy text-ivory grain">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            {settings?.logo_footer_url && (
              <img src={settings.logo_footer_url} alt="Silva Cotan e Associados — Assessoria Jurídica" className="h-24 w-auto" data-testid="footer-logo" />
            )}
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/60">
              Assessoria jurídica estratégica para empresas, empresários e profissionais. Estratégia • Prevenção • Atuação técnica.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-gold">Navegação</p>
            <ul className="mt-5 space-y-2.5">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-ivory/70 transition-colors hover:text-gold" data-testid={`footer-link-${item.to.replace(/\//g, "") || "inicio"}`}>
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/politica-de-privacidade" className="text-sm text-ivory/70 transition-colors hover:text-gold" data-testid="footer-link-privacidade">
                  Política de Privacidade
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-gold">Contato</p>
            <ul className="mt-5 space-y-3.5 text-sm text-ivory/70">
              {c.phone && (
                <li>
                  <a href={`tel:${c.phone.replace(/\D/g, "")}`} className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-phone-link">
                    <Phone size={15} className="text-gold" strokeWidth={1.5} /> {c.phone}
                  </a>
                </li>
              )}
              {c.whatsapp && (
                <li>
                  <a href={`https://wa.me/${c.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-whatsapp-link">
                    <Phone size={15} className="text-gold" strokeWidth={1.5} /> WhatsApp {c.phone}
                  </a>
                </li>
              )}
              {c.email && (
                <li>
                  <a href={`mailto:${c.email}`} className="flex items-center gap-3 break-all transition-colors hover:text-gold" data-testid="footer-email-link">
                    <Mail size={15} className="shrink-0 text-gold" strokeWidth={1.5} /> {c.email}
                  </a>
                </li>
              )}
              {c.instagram && (
                <li>
                  <a href={c.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-instagram-link">
                    <Instagram size={15} className="text-gold" strokeWidth={1.5} /> {c.instagram_handle || "Instagram"}
                  </a>
                </li>
              )}
              {c.linkedin && (
                <li>
                  <a href={c.linkedin} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-linkedin-link">
                    <Linkedin size={15} className="text-gold" strokeWidth={1.5} /> LinkedIn
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-ivory/10 pt-6 md:flex-row md:items-center">
          <p className="text-xs text-ivory/50">© {new Date().getFullYear()} Silva Cotan e Associados — Assessoria Jurídica. Todos os direitos reservados.</p>
          <p className="flex items-center gap-2 text-xs text-ivory/50">
            <ShieldCheck size={14} className="text-gold" strokeWidth={1.5} /> Dados tratados conforme a LGPD
          </p>
        </div>
      </div>
    </footer>
  );
}
